
<template>
  <v-container>
    <v-row justify="center" align="center" class="mt-5 mb-3">
      <v-btn large color="primary" class="ma-2" min-height="100px" min-width="400px" :outlined="!$router.currentRoute.path.includes(item.path)" :to="item.path" rounded v-for="(item, idx) in items" :key="'btn2'+idx">
        <v-row justify="center" class="text-center">
          <v-col cols="12" class="py-0">
            <v-icon class="mb-3" large>{{item.icon}}</v-icon>
          </v-col>
          <v-col cols="12" class="py-0">
            {{item.title}}
          </v-col>
        </v-row>
      </v-btn>
    </v-row> 

    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      items: [
        { title: 'Gerenciar Colaboradores',          path: '/settings/employees', icon: 'mdi-account-group' },
        // { title: 'Gerenciar Permissões',           path: '/settings/permissions', icon: 'mdi-lock-reset' },

      ]
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name2() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>